export const gatewayRenderer = record =>
	`${record.gatewayIdentifier.name}: ${record.gatewayIdentifier.version}`;
